module.exports = __webpack_public_path__ + "img/info_g.6f48e84c.svg";